import axios from "axios";
import { stage_url } from "../api-urls";
import Headers from "./Headers";

export async function GetPriceDrops(payload) {  
    return await axios.get(
        `${stage_url}/api-business-v3/price-drops/all`,
        {
            params: payload, 
            headers: Headers.getHeaders(true),
        }
    );
}


export async function addPriceDrop(payload) {
    return await axios.post(
        `${stage_url}api-business-v3/price-drops/save`, payload,
        {
            headers: Headers.getDukanHeaders(true),
        }
    );
}



export async function deletePriceDrop(priceDrop_id) {
    return await axios.get(
        `${stage_url}api-business-v3/price-drops/delete/${priceDrop_id}`,
        {
            headers: Headers.getHeaders(true),
        }
    );
}

